import { useQuery } from '@tanstack/react-query';

import { Fonts } from '@air/api';
import { callAirApi } from '@air/utils-api';

const FONTS_LIST_KEY = 'FONTS_LIST';

export type FontsListParams = Record<string, never>;

export const getFontsListKey = (params: FontsListParams) => {
  return [FONTS_LIST_KEY, params];
};

export type UseFontsListOptions = {
  enabled?: boolean;
};

export const useFontsList = (options?: UseFontsListOptions) => {
  return useQuery({
    enabled: options?.enabled,
    queryFn: () => callAirApi(() => Fonts.list({})),
    queryKey: getFontsListKey({}),
    staleTime: Infinity,
  });
};
